import React from 'react';
import useSubdomain from '../../utils/useSubdomain';
import { ReactComponent as Logo } from '../../assets/icons/SkipTracing-Logo.svg';

type AppLogoType = {
  className?: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
};

const AppLogo: React.FC<AppLogoType> = ({
  className,
  alt = 'logo',
  width = '400px',
  height = '80px',
}) => {
  const { config } = useSubdomain();
  const logoUrl = config.logoUrl;

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        className={className}
        alt={alt}
        style={{ maxWidth: width, maxHeight: height }}
      />
    );
  }

  return (
    <div className={className}>
      <Logo />
    </div>
  );
};

export default AppLogo;
